import { useEffect } from 'react';
import useLockedBody from '../../hooks/use-locked-body';

// If the user is in a fixed mobile layout, toggle scroll locking based
// on size of viewport and whether or not chat is shown
export default function useChatFixedMobileLayout(opts: {
  chatVisible: boolean;
  isMobilePortrait: boolean;
  broadcast: any;
}): void {
  const [locked, setLocked] = useLockedBody(false);

  // Toggle scroll locking based on size of viewport and whether or not chat is shown
  useEffect(() => {
    if (!locked && opts.isMobilePortrait && opts.chatVisible) {
      setLocked(true);
    } else if (locked) {
      setLocked(false);
    }
  }, [opts.chatVisible, opts.isMobilePortrait]);

  // Set the HTML CSS class that triggers the special override rules
  const root = document.getElementsByTagName('html')[0];
  useEffect(() => {
    root.classList.add('boxcast-chat-fixed-mobile-layout');
    return () => {
      root.classList.remove('boxcast-chat-fixed-mobile-layout');
    };
  }, [opts.broadcast]);

  // Always unlock the screen on component unmount
  useEffect(() => {
    return () => {
      setLocked(false);
    };
  }, [opts.broadcast]);
}
